import {VideosListContainer} from './styledComponents'

import HomePageVideoItem from '../HomePageVideoItem'

const HomePageVideosContainer = props => {
  const {videosList} = props
  return (
    <VideosListContainer>
      {videosList.map(eachItem => (
        <HomePageVideoItem details={eachItem} key={eachItem.id} />
      ))}
    </VideosListContainer>
  )
}
export default HomePageVideosContainer
